import * as types from "./actionTypes";

// Fetch Module
export const fetchEmployeeSalaryDefinition = (payload) => ({
  type: types.FETCH_EMPLOYEE_SALARY_DEFINITION,
  payload: payload
});

export const fetchEmployeeSalaryDefinitionSuccess = (payload) => ({
  type: types.FETCH_EMPLOYEE_SALARY_DEFINITION_SUCCESS,
  payload: payload,
});

export const fetchEmployeeSalaryDefinitionFailure = (error) => ({
  type: types.FETCH_EMPLOYEE_SALARY_DEFINITION_FAILURE,
  payload: error,
});

export const fetchEmployeeSalaryDefinitionClear = (response) => ({
  type: types.FETCH_EMPLOYEE_SALARY_DEFINITION_CLEAR,
  payload: response,
});

// Create Project
export const saveEmployeeSalaryDefinition = (formData, isEdit) => ({
  type: types.SAVE_EMPLOYEE_SALARY_DEFINITION,
  payload: { formData, isEdit },
});

export const saveEmployeeSalaryDefinitionSuccess = (response) => ({
  type: types.SAVE_EMPLOYEE_SALARY_DEFINITION_SUCCESS,
  payload: response,
});

export const saveEmployeeSalaryDefinitionFailure = (error) => ({
  type: types.SAVE_EMPLOYEE_SALARY_DEFINITION_FAILURE,
  payload: error,
});

export const fetchEmployeeSalaryIncrement = (payload) => ({
  type: types.FETCH_EMPLOYEE_SALARY_INCREMENT,
  payload: payload
});

export const fetchEmployeeSalaryIncrementSuccess = (response) => ({
  type: types.FETCH_EMPLOYEE_SALARY_INCREMENT_SUCCESS,
  payload: response,
});

export const fetchEmployeeSalaryIncrementFailure = (error) => ({
  type: types.FETCH_EMPLOYEE_SALARY_INCREMENT_FAILURE,
  payload: error,
});

export const getfinancialincrementtypes = (error) => ({
  type: types.FETCH_FINANCIAL_INCREMENT_TYPES,
  payload: error,
});

export const fetchActiveLoanTypes = (error) => ({
  type: types.FETCH_LOAN_TYPES,
  payload: error,
});

export const fetchempLoannumber = (error) => ({
  type: types.FETCH_LOAN_LOANNUMBER,
  payload: error,
});

export const fetchloaninstallments = (error) => ({
  type: types.FETCH_LOAN_MONTHLY_INSTALLMENTS,
  payload: error,
});

export const saveEmployeeLoandetails = (formData, isEdit) => ({
  type: types.SAVE_LOAN_MONTHLY_INSTALLMENTS,
  payload: { formData, isEdit },
});

export const fetchActiveEmployeeLoans = (formData, isEdit) => ({
  type: types.FETCH_EMPLOYEE_LOAN_LISTS,
  payload: { formData, isEdit },
});

export const getloaninstallmentdetails = (formData) => ({
  type: types.FETCH_EMPLOYEE_LOAN_INSTALLMENTS,
  payload: formData,
});

export const saveEmployeeSalaryIncrementCTC = (formData) => ({
  type: types.SAVE_EMPLOYEE_SALARY_INCREMENT_CTC,
  payload: { formData },
});

// Fetch Employee Salary Increment CTC
export const fetchEmployeeSalaryIncrementSavedCTC = (payload) => ({
  type: types.FETCH_EMPLOYEE_SALARY_INCREMENT_SAVED_CTC,
  payload: payload
});

export const fetchEmployeeSalaryIncrementSavedCTCSuccess = (response) => ({
  type: types.FETCH_EMPLOYEE_SALARY_INCREMENT_SAVED_CTC_SUCCESS,
  payload: response,
});

export const fetchEmployeeSalaryIncrementSavedCTCFailure = (error) => ({
  type: types.FETCH_EMPLOYEE_SALARY_INCREMENT_SAVED_CTC_FAILURE,
  payload: error,
});

export const fetchEmployeeIncrementApprovalCTC = (payload) => ({
  type: types.FETCH_EMPLOYEE_INCREMENT_APPROVAL_CTC,
  payload: payload
});

export const saveEmployeeIncrementApprovalCTC = (formData) => ({
  type: types.SAVE_EMPLOYEE_INCREMENT_APPROVAL_CTC,
  payload: { formData },
});

export const fetchEmployeeIncrementReport = (payload) => ({
  type: types.FETCH_EMPLOYEE_INCREMENT_REPORT,
  payload: payload
});

export const fetchempprecloseLoannumber = (payload) => ({
  type: types.FETCH_EMPLOYEE_LOAN_NO_PRECLOSE,
  payload: payload
});

export const getprecloseloancalculate = (payload) => ({
  type: types.FETCH_EMPLOYEE_PRECLOSE,
  payload: payload
});

export const saveEmployeepreloanclosedetails = (formData) => ({
  type: types.SAVE_LOAN_PRECLOSE,
  payload: { formData },
});

export const saveLoanfreezedetails = (formData) => ({
  type: types.SAVE_EMPLOYEE_LOAN_FREEZE,
  payload: { formData },
});

export const fetchemployeeloanfreeze = (formData) => ({
  type: types.FETCH_EMPLOYEE_LOAN_FREEZE,
  payload: formData,
});

export const getloanapprovaldetails = (formData) => ({
  type: types.FETCH_EMPLOYEE_LOAN_APPOVAL,
  payload: formData,
});

export const SaveLoanApprovals = (formData) => ({
  type: types.SAVE_EMPLOYEE_LOAN_APPOVALS,
  payload: { formData },
});

export const getsalaryscaledate = (formData) => ({
  type: types.FETCH_SALARY_GEN_SCALE,
  payload: formData,
});

export const saveSalaryGeneration = (formData) => ({
  type: types.SAVE_SALARY_GENERATION,
  payload: formData,
});

export const markerApproveGen = (formData) => ({
  type: types.SAVE_SALARY_GENERATION_LEAVE_APPROVALS,
  payload: { formData },
});

export const savegeneratesalary = (formData) => ({
  type: types.SAVE_SALARY_GENERATE,
  payload: { formData },
});

export const clearapproveError = () => ({
  type: "CLEAR_APPROVE_ERROR",
});

export const fetchsalarygeneratelog = (unit_id) => ({
  type: types.FETCH_SALARY_LOGS,
  payload: { unit_id },
});